import { Fragment, useEffect, useState } from "react";
import DashboardContainer from "../Common/Components/DashboardContainer";
import Filters from "./Filter";
import EventsGridWidget from "./GridWidget";
import { EventsType } from "../Common/Types/types";
import { EventsApi } from "./api";
import { getJiraParamsSelector } from "./JiraParamSlice";
import { useSelector } from "react-redux";
import JiraReportInfo from "./JiraReportInfo";
import { AuthApi } from "../Core/api";

const Events = () => {
  const positionData = [{ col: 1, colSpan: 6, rowSpan: 12 }];
  const [filteredEvents, updateFilteredEvents] = useState<EventsType[]>(null);
  const [eventsData, updateEventsData] = useState<EventsType[]>(null);
  const [errorMessage, setErrorMessage] = useState<string>(null);
  const [eventsIsLoading, updateEventsIsLoading] = useState<boolean>(false);
  const params = useSelector(getJiraParamsSelector);

  const [issue, updateIssue] = useState(false);
  const [visible, updateVisible] = useState(false);

    useEffect(() => {
            AuthApi.logUserEvent("Jira Reports")
        
    }, []);

  const toggleVisible = () => {
    visible ? updateVisible(false) : updateVisible(true);
  };

  const filteredEventsHandler = (data: EventsType[]) => {
    updateFilteredEvents(data);
  };

  const showWorkLogs = (selectedIssue: any) => {
    updateIssue(selectedIssue);
    visible ? updateVisible(false) : updateVisible(true);
  };

  const fetchEvents = (signal: any): void => {
    updateEventsIsLoading(true);
    updateEventsData(null);

    const newParams: {
      startDate: any;
      endDate: any;
    } = Object.assign(params, signal);
    EventsApi.getEvents(newParams)
      .then((response: any) => {
        if (response != "canceled") {
          //console.log(response);
          updateEventsData(response);
          updateFilteredEvents(response);
          updateEventsIsLoading(false);
        }
        setErrorMessage(null);
      })
      .catch((error) => {
        if (error.message != "canceled") {
          updateEventsIsLoading(false);
          setErrorMessage("Oops something went wrong, unable to get data.");
        }
        console.log(error);
      });
  };
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    fetchEvents(signal);
    return () => controller.abort();
  }, [, params]);
  const sidebarItems: { title: string; item: any; expanded: boolean }[] = [
    {
      title: "Filters",
      item: (
        <Filters
          filteredEventsHandler={filteredEventsHandler}
          data={eventsData}
          loading={eventsIsLoading}
        />
      ),
      expanded: true,
    },
  ];
  const defaultWidgets = [
    <EventsGridWidget
      id="1"
      header="JIRA Support Case Management Reports"
      term="text"
      filteredEvents={filteredEvents}
      loading={eventsIsLoading}
      error={errorMessage}
      showWorkLogs={showWorkLogs}
    />,
  ];
  return (
    <Fragment>
      <DashboardContainer
        positionData={positionData}
        sidebarItems={sidebarItems}
        defaultWidgets={defaultWidgets}
        addRemove={false}
        savable={false}
      />
      <JiraReportInfo
        issue={issue}
        visible={visible}
        toggleVisible={toggleVisible}
      />
    </Fragment>
  );
};
export default Events;
